import { render, staticRenderFns } from "./center-settings-v2.vue?vue&type=template&id=833e956c&scoped=true&"
import script from "./center-settings-v2.vue?vue&type=script&lang=ts&"
export * from "./center-settings-v2.vue?vue&type=script&lang=ts&"
import style0 from "./center-settings-v2.vue?vue&type=style&index=0&id=833e956c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833e956c",
  null
  
)

export default component.exports